import palette from '../palette';

export default {
  root: {
    "&:hover" : {
    },
    '&$selected': {
        backgroundColor: "red"
    //   backgroundColor: palette.background.default
    },
    '&$hover:hover': {
        borderSize: "4px",
        borderColor: "#DC9814",
        borderStyle: "solid",
        backgroundColor: "transparent"
        // backgroundColor: palette.background.default
      
    }
  }
};
